module.exports = __webpack_public_path__ + "static/media/select.96ce5d54.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/select.svg
// module id = 903
// module chunks = 0